import React from 'react';
import PropTypes from 'prop-types';

const RepoItem = ({ repo: { html_url, name } }) => {
  return (
    <div className='card'>
      <h2>
        <a href={html_url}>{name}</a>
      </h2>
    </div>
  );
};

RepoItem.propTypes = {
  repo: PropTypes.object.isRequired,
};

export default RepoItem;
